// Session boot: ONE request for everything the authenticated shell needs on first render
// (Performance Sprint, 2026-07). The backend resolves auth once and runs all sections
// concurrently. Each section is primed into the api.js GET micro-cache under the exact URL
// its existing consumer requests, so shell components render from cache with zero extra
// network round trips. Individual endpoints stay available for refetches after mutations
// (any write clears the cache, exactly as before).
import api, { primeCache } from "./api";

const PRIME_MAP = [
  ["user", "/auth/me"],
  ["home", "/home"],
  ["subscription", "/subscription"],
  ["capacity", "/household/capacity"],
  ["storage", "/storage"],
  ["onboarding", "/onboarding/me"],
  ["planni_context", "/planni/context"],
  ["notifications_unread", "/notifications/unread-count"],
  ["connect_unread", "/connect/unread-summary"],
  ["experience", "/experience"],
  ["announcements", "/announcements/active"],
  ["seasonal_picks", "/seasonal/picks?surface=home"],
  ["pinned_budgets", "/budget/budgets?pinned=1"],
];

export async function fetchBoot() {
  const { data } = await api.get("/session/boot");
  for (const [key, url] of PRIME_MAP) primeCache(url, data[key]);
  return data;
}
